import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import { SortDirection, SortDirections, SortKey } from '../utils';

interface Props {
	id: SortKey;
	label: string;
	sortDirection: SortDirection;
	sortKey: SortKey;
	onSort: (key: SortKey) => void;
}

const SortCell = ({ id, label, sortDirection, sortKey, onSort }: Props) => (
	<TableCell sortDirection={sortKey === id ? sortDirection : false}>
		<TableSortLabel
			active={sortKey === id}
			direction={sortKey === id ? sortDirection : SortDirections.asc}
			onClick={() => onSort(id)}
		>
			{label}
		</TableSortLabel>
	</TableCell>
);

export default SortCell;
